import React from 'react'

import { Theme } from '../../../../types/shared'
import { Heading, Paragraph } from '../../../components'
import { ChartEventBadgeType, ChartEventLabels } from '../../../constants/common'
import { CHART_EVENT_BADGE_SIZE } from '../badges/chart-badge-svg-by-type'
import { getChartEventBadgeElement } from '../badges/get-chart-event-badge-element'
import { ChartEventBadgeState, ISplit, getFormattedEventDate } from '../utils'

export function ChartEventSplitPopoverContent({
  badgeType,
  rawData,
  theme,
}: {
  badgeType: ChartEventBadgeType
  rawData: ISplit
  theme: Theme
}) {
  return (
    <>
      <div className="mb-3 flex space-x-1.5">
        {getChartEventBadgeElement({
          theme: theme,
          state: ChartEventBadgeState.default,
          width: CHART_EVENT_BADGE_SIZE,
          badgeType,
        })}{' '}
        <Heading className="my-0 text-base">{`${ChartEventLabels[badgeType]}: ${rawData.factorFrom}/${rawData.factorTo}`}</Heading>
      </div>
      <table>
        <tbody>
          <tr>
            <td>
              <Paragraph size="small">{getFormattedEventDate(rawData.dateTimestamp)}</Paragraph>
            </td>
          </tr>
        </tbody>
      </table>
    </>
  )
}
